import cn from "mcn";
import type React from "react";

export function ModalActionsRow({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { children: React.ReactNode }) {
  return (
    <div {...props} className={cn("flex flex-wrap justify-end gap-4", className)}>
      {children}
    </div>
  );
}
